import React, { useState } from 'react';
import { Input, Radio, Space } from 'antd';
import { MediaSelector } from './MediaSelector';
import type { MediaCategory } from '@shared/api/hooks/useMediaAssets';

interface MediaOrUrlFieldProps {
  category: MediaCategory;
  value?: string | null;
  onChange?: (url: string | null) => void;
  placeholder?: string;
}

/**
 * Dual-mode media field: scegli tra Repository Media o URL esterno.
 * Compatibile con Form.Item (value + onChange standard).
 * Il valore emesso è sempre string | null — compatibile con tutti i campi String? del DB.
 */
export function MediaOrUrlField({
  category,
  value,
  onChange,
  placeholder = 'https://...',
}: MediaOrUrlFieldProps): React.ReactElement {
  const [mode, setMode] = useState<'library' | 'url'>('library');

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={8}>
      <Radio.Group
        value={mode}
        onChange={(e) => setMode(e.target.value as 'library' | 'url')}
        size="small"
        optionType="button"
        buttonStyle="solid"
      >
        <Radio.Button value="library">Repository Media</Radio.Button>
        <Radio.Button value="url">URL esterno</Radio.Button>
      </Radio.Group>

      {mode === 'library' ? (
        <MediaSelector
          category={category}
          value={value}
          onChange={(url) => onChange?.(url)}
        />
      ) : (
        <Input
          value={value ?? ''}
          onChange={(e) => onChange?.(e.target.value || null)}
          placeholder={placeholder}
          allowClear
          onClear={() => onChange?.(null)}
        />
      )}
    </Space>
  );
}
